import { lang } from '@umu/ukit-lang';
import './quickRegisterDialog.scss';
import React, { Component, ComponentClass, FunctionComponent } from 'react';
import { getData } from '@umu/umu-util';
import { $window, $location, forceRefreshPage, updateUrlParameter } from '@umu/umu-dom';
import { components, services } from 'common';
const { Dialog, DialogBody, DialogFooter, DialogFooterButton, DialogHeader, If, modalServiceWrapper } = components;
const { Toast } = services;

import { getEnterpriseEnrollInfo } from '../../../@utils/umuUtil';
import MailInput from '../@mailInput/mailInput';
import PasswordInput from '../@passwordInput/passwordInput';
import PhoneInput, { IChangeCallbackArgs } from '../@phoneInput/phoneInput';
import PhoneVerification from '../@phoneVerification/phoneVerification';

import {
    accountDataService,
    IAPIResponse,
    REGISTER_BY,
    setSiteLang,
    storageCurrentUserId,
    validateMail,
    validatePhone,
    validateNewRulePswd,
} from '../../../services/accountService';
import { iframePageGlobalStore } from '../../../services/responsiveDisplay/course';
import { childPostControl } from '@umu/umu-iframe/src/session/postMessage/childPostControl';
import {
    SessionMessageAction,
    IIframeNeedLoginACKChild,
} from '@umu/umu-iframe/src/session/messageActions';

let DEFAULT_REGISTER_BY: string;

DEFAULT_REGISTER_BY = REGISTER_BY.MAIL;

// 目前有以下几种类型的登录弹窗，如果需要在这里进行扩展
type TDialogType = 'LOGIN' | 'PARTICIPATE' | 'ENROLL' | 'FOLLOW';

enum ETitleMap {
    'LOGIN' = lang('需要登录'),
    'PARTICIPATE' = lang('需要登录参与'),
    'ENROLL' = lang('需要报名参与'),
    'FOLLOW' = lang('需要登录关注'),
    'PROGRAM_ENROLL' = lang('需要报名参与'),
}

enum ETipMap {
    'LOGIN' = lang('课程所有者设置为需要登录参与，如果您已有UMU账户，请'),
    'PARTICIPATE' = lang('课程所有者设置为需要登录参与，如果您已有UMU账户，请'),
    'ENROLL' = lang('该课程需要报名，如果您已有UMU账户，请'),
    'FOLLOW' = lang('您需要登录，才能关注当前讲师，如果您已有UMU账户，请'),
    'PROGRAM_ENROLL' = lang('该学习项目需要报名，如果您已有UMU账户，请'),
}

enum ESignupTipMap {
    'LOGIN' = lang('如果您第一次使用，请填写以下信息并点击“下一步”，仅需简单一步即可创建账户。'),
    'PARTICIPATE' = lang('如果您第一次使用，请填写以下信息并点击“下一步”，仅需简单一步即可创建账户。'),
    'ENROLL' = lang('如果您第一次使用，请填写以下信息并点击“下一步”，仅需简单一步即可创建账户。'),
    'FOLLOW' = lang('如果您第一次使用，请填写以下信息并点击“下一步”，仅需简单一步即可创建账户。'),
    'PROGRAM_ENROLL' = lang('如果您第一次使用，请填写以下信息并点击“下一步”，仅需简单一步即可创建账户，完成报名流程。'),
}

interface IWrapperConfig {
    appendTo?: string;
    contentComponent?: ComponentClass<any> | FunctionComponent<any>;
}

interface IProps extends IWrapperConfig {
    dialogType: TDialogType;
    showDialog?: boolean;
    canClose?: boolean;
    loginPageUrlParams?: string;
    groupId?: string;
    emailList?: string[];
    close?: () => void;
    success?: (ret?: IAPIResponse) => void;
}

interface IState {
    name: string;
    phone: string;
    areaCode: string;
    passwd: string;
    codePosition: string;
    email: string;
    checkCode: string;

    hasVoiceSMS: boolean;
    processing: boolean;
    showVerify: boolean;
    showPasswd: boolean;

    showNameMsg: boolean;
    showPhoneMsg: boolean;
    showPswdMsg: boolean;
    showMailMsg: boolean;
    accountUsed: boolean;
}

class QuickRegisterDialog extends Component<IProps, IState> {
    public static defaultProps = {
        showDialog: true,
    };
    public registerBy: string;

    public loginPageUrl: string;

    /**
     * 是否正在提交
     */
    private isSubmitting: boolean;

    constructor(props: IProps) {
        super(props);

        this.registerBy = DEFAULT_REGISTER_BY;

        this.isSubmitting = false;

        this.toNextStep = this.toNextStep.bind(this);
        this.checkAccount = this.checkAccount.bind(this);

        this.nameChangeCallback = this.nameChangeCallback.bind(this);
        this.phoneChangeCallback = this.phoneChangeCallback.bind(this);
        this.mailChangeCallback = this.mailChangeCallback.bind(this);
        this.pswdChangeCallback = this.pswdChangeCallback.bind(this);
        this.codeChangeCallback = this.codeChangeCallback.bind(this);

        this.codeVerifyCallback = this.codeVerifyCallback.bind(this);
        this.passwdVerifyCallback = this.passwdVerifyCallback.bind(this);
        this.submitButtonClick = this.submitButtonClick.bind(this);

        this.sendSms = this.sendSms.bind(this);
        this.sendSmsSuccessCallback = this.sendSmsSuccessCallback.bind(this);
        this.resendCallback = this.resendCallback.bind(this);

        this.loginFinishCallback = this.loginFinishCallback.bind(this);

        this.back = this.back.bind(this);
        this.close = this.close.bind(this);

        // ------------------- loginPageUrl ------------------
        this.loginPageUrl = $location.origin + '/globaluser/loginpage';
        this.loginPageUrl += '?from_url=' + encodeURIComponent($location.href);

        // 使用自定义的登录链接参数
        this.loginPageUrl += props.loginPageUrlParams || '';

        this.state = this.getDefaultState() as IState;
    }

    public getDefaultState() {
        return {
            name: '',
            phone: '',
            areaCode: '',
            passwd: '',
            codePosition: '',
            email: '',
            checkCode: '',

            hasVoiceSMS: false,
            processing: false,
            showVerify: false,
            showPasswd: false,
        };
    }

    // 监听表单内容 onChange
    public nameChangeCallback(e: React.ChangeEvent<HTMLInputElement>) {
        const value = (e.currentTarget.value || '').trim();
        this.setState({
            name: value,
        });
    }

    public phoneChangeCallback(data: IChangeCallbackArgs) {
        this.setState({
            codePosition: data.selectedCountryPosition + '',
            areaCode: data.countryCode + '',
            phone: data.phoneNumber + '',
        });
    }

    public mailChangeCallback(data: string) {
        this.setState({
            email: data,
        });
    }

    public pswdChangeCallback(data: string) {
        this.setState({
            passwd: data,
        });
    }

    public codeChangeCallback(data: string) {
        this.setState({
            checkCode: data,
        });
    }
    // --监听表单内容 onChange

    // 表单内容提交前验证
    public checkName(name: string) {
        const result = (name || '').trim() !== '';
        this.setState({
            showNameMsg: !result,
        });
        return result;
    }

    public checkPhone(phone: string) {
        const result = validatePhone(phone);
        this.setState({
            showPhoneMsg: !result,
        });
        return result;
    }

    public checkPswd(passwd: string) {
        const result = validateNewRulePswd(passwd);
        this.setState({
            showPswdMsg: !result,
        });
        return result;
    }

    public checkMail(email: string) {
        const result = validateMail(email);
        this.setState({
            showMailMsg: !result,
        });
        return result;
    }
    // --表单内容提交前验证

    // 切换下一步
    public toNextStep() {
        if (this.state.processing) {
            return;
        }

        if (!this.checkName(this.state.name)) {
            return;
        }

        if (this.registerBy === REGISTER_BY.PHONE) {
            if (!this.checkPhone(this.state.phone)) {
                return;
            }
            this.sendSms();
        } else if (!this.checkAccount()) {
            return;
        }

        this.setState({
            processing: true,
        });
    }

    // 发送验证码
    public sendSms(isVoice?: boolean) {
        const { enterpriseId } = getEnterpriseEnrollInfo();
        // 手机则请求验证码，进入输入验证码页面
        const formData = {
            'eid': enterpriseId,
            'area_code': this.state.areaCode,
            'phone': this.state.phone,
            'data[data_type]': 8, // 8、注册,9、找回密码
            'type': isVoice ? 2 : 1, // 1:数字，2:语音
        };
        if (!this.checkPhone(formData.phone)) {
            return;
        }

        accountDataService.getVerifyCode(formData).then(
            (ret: IAPIResponse) => {
                if (!ret.status) {
                    this.sendSmsSuccessCallback(ret);
                    return;
                }
                this.sendSmsSuccessCallback(null, ret);
            },
            (err: IAPIResponse) => {
                this.sendSmsSuccessCallback(err);
            },
        );
    }

    public sendSmsSuccessCallback(err: IAPIResponse | null, ret?: IAPIResponse) {
        if (err) {
            Toast.show({
                message: err.error,
            });
            this.setState({
                processing: false,
            });
            return;
        }

        if (!ret) {
            return;
        }

        this.setState({
            hasVoiceSMS: ret.data.has_voice_sms,
            processing: false,
            showVerify: true,
        });
    }

    // 检查账号是否已注册
    public checkAccount() {
        const formData = {
            account: this.state.email,
            type: 'email',
        };

        if (!this.checkMail(this.state.email)) {
            return;
        }

        accountDataService.checkAccount(formData).then(
            (ret: IAPIResponse) => {
                if (!ret.status) {
                    this.checkAccountSuccess(ret);
                    return;
                }
                this.checkAccountSuccess(null, ret);
            },
            (err: IAPIResponse) => {
                this.checkAccountSuccess(err);
            },
        );

        return true;
    }

    public checkAccountSuccess(err: IAPIResponse | null, ret?: IAPIResponse) {
        if (err) {
            Toast.show({
                message: err.error,
            });
            this.setState({
                processing: false,
            });
            return;
        }

        if (!ret) {
            return;
        }

        this.setState({
            processing: false,
            accountUsed: ret.data.is_registered,
            showPasswd: true, // 目前只检查邮箱，所以逻辑放在这里
        });
    }

    public resendCallback(isVoice?: boolean) {
        this.sendSms(isVoice);
    }

    // 手机验证码页面的提交
    public codeVerifyCallback() {
        const code = this.state.checkCode;
        let formData = {
            'name': this.state.name,
            'data[data_type]': 8,
            'area_code': this.state.areaCode,
            'phone': this.state.phone,
            'check_code': code,
        };
        if (this.props.groupId) {
            formData = Object.assign(formData, {
                bl_param: this.props.groupId, // 统计参数
            });
        }

        // 企业定制登录需求
        const { enterpriseId } = getEnterpriseEnrollInfo();
        if (enterpriseId) {
            formData = Object.assign(formData, {
                enterprise_id: enterpriseId,
            });
        }

        this.setState({
            checkCode: code,
            processing: true,
        });
        accountDataService.verifyCode(formData).then(
            (retData: IAPIResponse) => {
                if (!retData.status) {
                    this.loginFinishCallback(retData);
                    return;
                }
                accountDataService.registerQuickSubmit(formData).then(
                    (ret: IAPIResponse) => {
                        if (!ret.status) {
                            this.loginFinishCallback(ret);
                            return;
                        }

                        // gdpr
                        const studentId = getData(ret, 'data', 'teacher_info', 'student_id');
                        storageCurrentUserId(studentId);

                        // 设置语言偏好
                        setSiteLang('', true);
                        this.loginFinishCallback(null, ret);
                    },
                    (err: IAPIResponse) => {
                        this.loginFinishCallback(err);
                    },
                );
            },
            (err: IAPIResponse) => {
                this.loginFinishCallback(err);
            },
        );
    }

    // 密码页面的提交
    public passwdVerifyCallback() {
        // 邮箱则提交，进入完善资料
        let formData = {
            name: this.state.name,
            email: this.state.email,
            passwd: this.state.passwd,
        };
        if (this.props.groupId) {
            formData = Object.assign(formData, {
                bl_param: this.props.groupId, // 统计参数
            });
        }

        if (!this.checkPswd(formData.passwd)) {
            return;
        }

        this.setState({
            processing: true,
        });

        accountDataService.registerQuickSubmit(formData).then(
            (ret: IAPIResponse) => {
                if (!ret.status) {
                    this.loginFinishCallback(ret);
                    return;
                }
                // 设置语言偏好
                setSiteLang('', true);
                this.loginFinishCallback(null, ret);
            },
            (err: IAPIResponse) => {
                this.loginFinishCallback(err);
            },
        );
    }

    // 提交
    public submitButtonClick() {
        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;

        if (this.state.showVerify) {
            this.codeVerifyCallback();
        } else if (this.state.showPasswd) {
            this.passwdVerifyCallback();
        }
    }

    // 提交后的回调
    public loginFinishCallback(err: IAPIResponse | null, returnData?: IAPIResponse) {
        this.isSubmitting = false;

        if (err) {
            Toast.show({
                message: err.error,
            });
            this.setState({
                processing: false,
            });
            return;
        }

        const success = (ret?: IAPIResponse) => {
            if (ret && ret.data.activate_url) {
                window.location.href = updateUrlParameter(ret.data.activate_url, 'from_url', $window.location.href);
                return;
            }
            const callback =
                this.props.success ||
                (() => {
                    window.location.reload();
                    setTimeout(forceRefreshPage, 2000);
                });
            callback(ret);
        };
        success(returnData);
    }

    public back() {
        this.setState({
            showVerify: false,
            showPasswd: false,
        });
    }

    public close() {
        if (this.props.close) {
            this.props.close();
        }
        this.setState(this.getDefaultState());
    }

    public renderMainPage() {
        if (this.state.showVerify || this.state.showPasswd) {
            return;
        }

        return (
            <div className="quick-register-dialog-main">
                <div className="page-body">
                    <div className="quick-login-tip">
                        <p>
                            {ETipMap[this.props.dialogType]}
                            <a href={this.loginPageUrl} target='_self'>{lang('立即登录')}</a>
                            {lang('。')}
                        </p>
                        <p>{ESignupTipMap[this.props.dialogType]}</p>
                    </div>
                    <div className="form form-sign">
                        <div className="form-row">
                            <div className="input lined">
                                <input
                                    type="text"
                                    placeholder={lang('姓名')}
                                    defaultValue={this.state.name}
                                    onChange={this.nameChangeCallback}
                                />
                            </div>
                            <If condition={this.state.showNameMsg}>
                                <p className="form-tip error">{lang('请输入您的姓名')}</p>
                            </If>
                        </div>
                        <If condition={this.registerBy !== REGISTER_BY.MAIL}>
                            <div className="form-row">
                                <PhoneInput
                                    initialPhone={this.state.phone}
                                    initialValue={this.state.areaCode}
                                    initialPosition={this.state.codePosition}
                                    changeCallback={this.phoneChangeCallback}
                                />
                                <If condition={this.state.showPhoneMsg}>
                                    <p className="form-tip error">{lang('请输入正确的手机号')}</p>
                                </If>
                            </div>
                        </If>
                        <If condition={this.registerBy === REGISTER_BY.MAIL}>
                            <div className="form-row mail-input-wrap">
                                <MailInput
                                    initialVal={this.state.email}
                                    isShowSuggestion={false}
                                    changeCallback={this.mailChangeCallback}
                                    mailVendors={this.props.emailList}
                                    placeholder={lang('请输入电子邮箱')}
                                />
                                <If condition={this.state.showMailMsg}>
                                    <p className="form-tip error">{lang('请输入有效的电子邮箱')}</p>
                                </If>
                            </div>
                        </If>
                    </div>
                </div>
            </div>
        );
    }

    public renderVerifyPage() {
        if (!this.state.showVerify) {
            return;
        }

        return (
            <div className="quick-register-dialog-main">
                <div className="page-body">
                    <PhoneVerification
                        processing={this.state.processing}
                        areaCode={this.state.areaCode}
                        phoneNum={this.state.phone}
                        hasVoiceSMS={this.state.hasVoiceSMS}
                        codeChangeCallback={this.codeChangeCallback}
                        resendCallback={this.resendCallback}
                    />
                </div>
            </div>
        );
    }

    public renderPasswdPage() {
        if (!this.state.showPasswd) {
            return;
        }

        return (
            <div className="quick-register-dialog-main">
                <div className="page-body">
                    <div className="form">
                        <div className="form-body">
                            <div className="form-row">
                                <PasswordInput
                                    changeCallback={this.pswdChangeCallback}
                                    placeholder={lang('请输入密码')}
                                />
                                <If condition={this.state.showPswdMsg}>
                                    <p className="form-tip error">{lang('请输入密码，不少于8位的数字和字母组合')}</p>
                                </If>
                            </div>
                            <div className="form-row">
                                <div className="passwd-info">
                                    <div className="title">{this.state.email}</div>
                                    <If condition={this.state.accountUsed}>
                                        <div className="desc">{lang('当前邮箱已注册UMU，请输入密码登录')}</div>
                                    </If>
                                    <If condition={!this.state.accountUsed}>
                                        <div className="desc">{lang('请设置密码')}</div>
                                    </If>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public renderQuickRegisterDialog() {
        let canClose = this.props.canClose;
        if (typeof canClose === 'undefined') {
            canClose = true;
        }

        return (
            <Dialog
                show={!!this.props.showDialog}
                hasMask={true}
                className="quick-register-dialog"
                canClose={canClose}
                close={this.close}
                width="300px"
            >
                <DialogHeader>
                    <div className="dialog-title">{ETitleMap[this.props.dialogType]}</div>
                </DialogHeader>
                <DialogBody>
                    {this.renderMainPage()}
                    {this.renderVerifyPage()}
                    {this.renderPasswdPage()}
                </DialogBody>
                <If condition={!this.state.showPasswd && !this.state.showVerify}>
                    <DialogFooter>
                        <DialogFooterButton href={this.loginPageUrl} target='_self'>{lang('已有账户，登录')}</DialogFooterButton>
                        <DialogFooterButton
                            onClick={this.toNextStep}
                            className={this.state.processing ? 'disabled' : ''}
                        >
                            {lang('下一步')}
                        </DialogFooterButton>
                    </DialogFooter>
                </If>
                <If condition={this.state.showPasswd || this.state.showVerify}>
                    <DialogFooter>
                        <DialogFooterButton onClick={this.back}>{lang('返回')}</DialogFooterButton>
                        <DialogFooterButton
                            onClick={this.submitButtonClick}
                            className={this.state.processing ? 'disabled' : ''}
                        >
                            {lang('确定')}
                        </DialogFooterButton>
                    </DialogFooter>
                </If>
            </Dialog>
        );
    }

    public render() {
        return this.renderQuickRegisterDialog();
    }
}

const showQuickRegisterDialog = (arg: any) => {
    if (iframePageGlobalStore.isIframeMode) {
        // 让父页面处理登录
        const payload: IIframeNeedLoginACKChild = {
            action: SessionMessageAction.needLogin,
            data: {
                url: location.href,
            },
        };
        childPostControl.sendMsg(payload);
    } else {
        modalServiceWrapper(QuickRegisterDialog).apply(modalServiceWrapper, [arg])
    }
};
export default showQuickRegisterDialog;
